module.exports = __webpack_public_path__ + "static/media/newhome.be2d5e99.svg";